"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
async function preload(url, loaderCallback) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
            if (this.status == 200) {
                // window.setTimeout(() => {
                resolve(this.response);
                // }, 3000)
            }
            if (this.status == 404) {
                reject();
            }
        };
        xhr.onprogress = function (event) {
            if (event.lengthComputable) {
                const percentComplete = event.loaded / event.total * 100;
                loaderCallback(Math.round(percentComplete * 100) / 100, event.loaded, event.total);
            }
        };
        xhr.onerror = reject;
        xhr.send();
    });
}
exports.default = preload;
